import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  CATALOG_TREE: '/dh-datamaint/caseCatalog/listTreeByVersionId',
  PAGE: '/dh-datamaint/case/page',
  DETAIL: '/dh-datamaint/case/getById',
  ADD: '/dh-datamaint/case/add',
  UPDATE: '/dh-datamaint/case/update',
  UPDATE_LIST: '/dh-datamaint/case/baseInfo/update',
  BATCH_DELETE: '/dh-datamaint/case/batchDelete',
  GET_SORT: '/dh-datamaint/case/getSort',
  SORT: '/dh-datamaint/case/sort',
};

class CaseManagerModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getCatalogTree(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.CATALOG_TREE, { params: payload.data });
    },

    async getPage(context: ActionContext<any, any>, payload: any) {
      const { pageNo, pageSize, ...data } = payload.data || {};
      return await ajax.post(URL.PAGE, data, { params: { pageNo, pageSize } });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async getSort(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_SORT, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async UpdateList(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE_LIST, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.BATCH_DELETE, { ids: payload.data });
    },

    async sort(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.SORT, payload.data);
    },

    async getPreview(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    }
  };
}

export const caseManagerModule = new CaseManagerModule();
